import axios from 'axios'

export default {
  // ======================================================================
  // ==========================List Management=============================
  // ======================================================================
  panelList (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/panel', { params: opts })
        .then(({ data }) => {
          context.commit('PANEL_LIST', data)
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  // ==========================Socket Updates==============================
  panelCreated (context, opts) {
    // do nothing
  },
  panelUpdated (context, opts) {
    const id = typeof opts === 'string' ? opts : opts && opts.id ? opts.id : '#'
    const inputs = { }
    if (opts && Array.isArray(opts.populate) && opts.populate.length > 0) {
      inputs.params = { }
      inputs.params.populate = opts.populate
    }
    const inList = context.state.list.find((i) => i.id === id)
    if (context.state.current.id === id || inList) {
      axios
        .get(`/api/panel/${id}`, inputs)
        .then(({ data }) => {
          if (data.id === context.state.current.id) {
            context.commit('PANEL_CURRENT', data)
          }
          if (inList) {
            context.commit('PANEL_LIST_UPDATE', data)
          }
        }).catch(() => {
        })
    }
  },
  panelDestroyed (context, opts) {
    // always try to remove from list
    const id = typeof opts === 'string' ? opts : opts && opts.id ? opts.id : '#'
    if (id === context.state.current.id) {
      context.commit('PANEL_CURRENT', null)
    }
    context.commit('PANEL_LIST_ITEM_REMOVE', opts)
  },
  // ======================================================================
  // ==========================Item Management=============================
  // ======================================================================
  panelDetail (context, opts) {
    const id = typeof opts === 'string' ? opts : opts && opts.id ? opts.id : '#'
    const inputs = { }
    if (opts && Array.isArray(opts.populate) && opts.populate.length > 0) {
      inputs.params = { }
      inputs.params.populate = opts.populate
    }
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/panel/${id}`, inputs)
        .then(({ data }) => {
          context.commit('PANEL_CURRENT', data)
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  panelHistory (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/panel/history', { params: { id: opts } })
        .then(({ data }) => {
          context.commit('PANEL_CURRENT_HISTORY', data)
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  panelUpdate (context, opts) {
    const updates = Object.assign({}, context.state.update)
    for (const key of Object.keys(updates)) {
      if (updates[key] === null) {
        delete updates[key]
      }
    }
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/panel/${context.state.current.id}`, updates)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  bulkUpdatePanels (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .patch('/api/panel/bulkupdate', opts)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  }
}
